var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "claim-landing view" },
    [
      _c("div", { staticClass: "view_content" }, [
        _c(
          "div",
          { staticClass: "view_content_markdown" },
          [
            _vm._l(_vm.getFlowViewContent, function (content) {
              return [
                content.type === "TITLE"
                  ? _c("h1", [_vm._v(_vm._s(content.literal))])
                  : _vm._e(),
                content.type === "PARAGRAPH"
                  ? _c("p", [_vm._v(_vm._s(content.literal))])
                  : _vm._e(),
                content.type === "BULLET"
                  ? _c("span", { staticClass: "bullet" }, [
                      _c("img", {
                        staticClass: "icon",
                        attrs: {
                          src: require("@/assets/images/self-care/circlechecked.png"),
                        },
                      }),
                      _c("p", [_vm._v(_vm._s(content.literal))]),
                    ])
                  : _vm._e(),
                content.type === "BULLET_ICON"
                  ? _c("div", { staticClass: "bullet-icon" }, [
                      _c("img", {
                        staticClass: "bullet-icon-img",
                        attrs: { src: content.image },
                      }),
                      _c("p", { staticClass: "bullet-icon-text" }, [
                        _vm._v(" " + _vm._s(content.literal)),
                      ]),
                    ])
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
      _c(
        "div",
        { staticClass: "view_actions" },
        [
          _c("ma-confirm-button", {
            attrs: {
              handleButtonClick: _vm.handleClickStartBtn,
              title: _vm.$t("claim.onboarding.actions.mainBlue"),
              btnType: "functionalBtn",
            },
          }),
          _c("div", { staticClass: "claim-onboarding" }),
        ],
        1
      ),
      _vm.isManageDamageAppointmentFlow
        ? [
            _vm.isRenProfessionalUser || _vm.isBillmaAgentUserNew
              ? _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "title mg mg--b-6 welcome" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "claim.onboarding.isManageDamageAppointmentFlow.isRenProfessionalUser.title"
                        )
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "subtitle" }, [
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-4 subtitle_p" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageAppointmentFlow.isRenProfessionalUser.content.literal1"
                            )
                          )
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: {
                          src: require("@/assets/images/self-care/circlechecked.png"),
                        },
                      }),
                      _c("p", { staticClass: "text-medium mg mg--b-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageAppointmentFlow.isRenProfessionalUser.content.bullet1"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: {
                          src: require("@/assets/images/self-care/circlechecked.png"),
                        },
                      }),
                      _c("p", { staticClass: "text-medium mg mg--b-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageAppointmentFlow.isRenProfessionalUser.content.bullet2"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: {
                          src: require("@/assets/images/self-care/circlechecked.png"),
                        },
                      }),
                      _c("p", { staticClass: "text-medium mg mg--b-6" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "claim.onboarding.isManageDamageAppointmentFlow.isRenProfessionalUser.content.bullet3"
                              )
                            )
                        ),
                      ]),
                    ]),
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-6 subtitle_p" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageAppointmentFlow.isRenProfessionalUser.content.literal2"
                            )
                          )
                        ),
                      ]
                    ),
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-2 subtitle_p" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageAppointmentFlow.isRenProfessionalUser.content.literal3"
                            )
                          )
                        ),
                      ]
                    ),
                    _c("p", { staticClass: "text-medium subtitle_p" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "claim.onboarding.isManageDamageAppointmentFlow.isRenProfessionalUser.content.literal4"
                          )
                        )
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.isRenInsuredUser
              ? _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "title mg mg--b-6 welcome" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "claim.onboarding.isManageDamageAppointmentFlow.isRenInsuredUser.title"
                        )
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "subtitle" }, [
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-4 subtitle_p" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageAppointmentFlow.isRenInsuredUser.content.literal1"
                            )
                          )
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: {
                          src: require("@/assets/images/self-care/circlechecked.png"),
                        },
                      }),
                      _c("p", { staticClass: "text-medium mg mg--b-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageAppointmentFlow.isRenInsuredUser.content.bullet1"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: {
                          src: require("@/assets/images/self-care/circlechecked.png"),
                        },
                      }),
                      _c("p", { staticClass: "text-medium mg mg--b-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageAppointmentFlow.isRenInsuredUser.content.bullet2"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: {
                          src: require("@/assets/images/self-care/circlechecked.png"),
                        },
                      }),
                      _c("p", { staticClass: "text-medium mg mg--b-6" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "claim.onboarding.isManageDamageAppointmentFlow.isRenInsuredUser.content.bullet3"
                              )
                            )
                        ),
                      ]),
                    ]),
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-6 subtitle_p" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageAppointmentFlow.isRenInsuredUser.content.literal2"
                            )
                          )
                        ),
                      ]
                    ),
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-2 subtitle_p" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageAppointmentFlow.isRenInsuredUser.content.literal3"
                            )
                          )
                        ),
                      ]
                    ),
                    _c("p", { staticClass: "text-medium subtitle_p" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "claim.onboarding.isManageDamageAppointmentFlow.isRenInsuredUser.content.literal4"
                          )
                        )
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]
        : _vm.isManageDamageGAGFlow
        ? [
            _vm.isInsuredUser
              ? _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "title mg mg--b-6 welcome" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "claim.onboarding.isManageDamageGAGFlow.isInsuredUser.title"
                        )
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "subtitle" }, [
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-2 subtitle_p" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageGAGFlow.isInsuredUser.content.literal1"
                            )
                          )
                        ),
                      ]
                    ),
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-6 subtitle_p" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "claim.onboarding.isManageDamageGAGFlow.isInsuredUser.content.literal2"
                              )
                            )
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: {
                          src: require("@/assets/images/self-care/circlechecked.png"),
                        },
                      }),
                      _c("p", { staticClass: "text-medium mg mg--b-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageGAGFlow.isInsuredUser.content.bullet1"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: {
                          src: require("@/assets/images/self-care/circlechecked.png"),
                        },
                      }),
                      _c("p", { staticClass: "text-medium mg mg--b-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageGAGFlow.isInsuredUser.content.bullet2"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: {
                          src: require("@/assets/images/self-care/circlechecked.png"),
                        },
                      }),
                      _c("p", { staticClass: "text-medium mg mg--b-6" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "claim.onboarding.isManageDamageGAGFlow.isInsuredUser.content.bullet3"
                              )
                            )
                        ),
                      ]),
                    ]),
                    _c("p", { staticClass: "text-medium subtitle_p" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "claim.onboarding.isManageDamageGAGFlow.isInsuredUser.content.literal3"
                          )
                        )
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]
        : _vm.isManageDamageContactFlow
        ? [
            _vm.isProfessionalUser
              ? _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "title mg mg--b-6 welcome" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "claim.onboarding.isManageDamageContactFlow.isProfessionalUser.title"
                        )
                      )
                    ),
                  ]),
                  _c(
                    "p",
                    { staticClass: "text-medium mg mg--b-2 subtitle_p" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "claim.onboarding.isManageDamageContactFlow.isProfessionalUser.content.literal1"
                          )
                        )
                      ),
                    ]
                  ),
                  _c(
                    "p",
                    { staticClass: "text-medium mg mg--b-2 subtitle_p" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "claim.onboarding.isManageDamageContactFlow.isProfessionalUser.content.literal2"
                          )
                        )
                      ),
                    ]
                  ),
                  _c(
                    "p",
                    { staticClass: "text-medium mg mg--b-6 subtitle_p" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "claim.onboarding.isManageDamageContactFlow.isProfessionalUser.content.literal3"
                          )
                        )
                      ),
                    ]
                  ),
                  _c(
                    "p",
                    { staticClass: "text-medium mg mg--b-2 subtitle_p" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "claim.onboarding.isManageDamageContactFlow.isProfessionalUser.content.literal4"
                          )
                        )
                      ),
                    ]
                  ),
                  _c("p", { staticClass: "text-medium subtitle_p" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "claim.onboarding.isManageDamageContactFlow.isProfessionalUser.content.literal5"
                        )
                      )
                    ),
                  ]),
                ])
              : _vm.isBillmaInsuredUser
              ? _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "title mg mg--b-6 welcome" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "claim.onboarding.isManageDamageContactFlow.isBillmaInsuredUser.title"
                        )
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "subtitle" }, [
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-2 subtitle_p" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageContactFlow.isBillmaInsuredUser.content.literal1"
                            )
                          )
                        ),
                      ]
                    ),
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-2 subtitle_p" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageContactFlow.isBillmaInsuredUser.content.literal2"
                            )
                          )
                        ),
                      ]
                    ),
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-6 subtitle_p" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "claim.onboarding.isManageDamageContactFlow.isBillmaInsuredUser.content.literal3"
                              )
                            )
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: {
                          src: require("@/assets/images/self-care/circlechecked.png"),
                        },
                      }),
                      _c("p", { staticClass: "text-medium mg mg--b-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageContactFlow.isBillmaInsuredUser.content.bullet1"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: {
                          src: require("@/assets/images/self-care/circlechecked.png"),
                        },
                      }),
                      _c("p", { staticClass: "text-medium mg mg--b-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageContactFlow.isBillmaInsuredUser.content.bullet2"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: {
                          src: require("@/assets/images/self-care/circlechecked.png"),
                        },
                      }),
                      _c("p", { staticClass: "text-medium mg mg--b-6" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "claim.onboarding.isManageDamageContactFlow.isBillmaInsuredUser.content.bullet3"
                              )
                            )
                        ),
                      ]),
                    ]),
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-2 subtitle_p" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageContactFlow.isBillmaInsuredUser.content.literal4"
                            )
                          )
                        ),
                      ]
                    ),
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-2 subtitle_p" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageContactFlow.isBillmaInsuredUser.content.literal5"
                            )
                          )
                        ),
                      ]
                    ),
                    _c("p", { staticClass: "text-medium subtitle_p" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "claim.onboarding.isManageDamageContactFlow.isBillmaInsuredUser.content.literal6"
                          )
                        )
                      ),
                    ]),
                  ]),
                ])
              : _vm.isBillmaAgentUser || _vm.isBillmaAgentUserNew
              ? _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "title mg mg--b-6 welcome" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "claim.onboarding.isManageDamageContactFlow.isBillmaAgentUser.title"
                        )
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "subtitle" }, [
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-2 subtitle_p" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageContactFlow.isBillmaAgentUser.content.literal1"
                            )
                          )
                        ),
                      ]
                    ),
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-2 subtitle_p" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageContactFlow.isBillmaAgentUser.content.literal2"
                            )
                          )
                        ),
                      ]
                    ),
                    _c(
                      "p",
                      { staticClass: "text-medium mg mg--b-2 subtitle_p" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageContactFlow.isBillmaAgentUser.content.literal3"
                            )
                          )
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: { src: require("@/assets/clock.png") },
                      }),
                      _c("p", { staticClass: "check-img-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageContactFlow.isBillmaAgentUser.content.bullet1"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: { src: require("@/assets/camera.png") },
                      }),
                      _c("p", { staticClass: "check-img-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "claim.onboarding.isManageDamageContactFlow.isBillmaAgentUser.content.bullet2"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "container-check" }, [
                      _c("img", {
                        staticClass: "check-img",
                        attrs: { src: require("@/assets/smartphone.png") },
                      }),
                      _c("p", { staticClass: "check-img-text" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "claim.onboarding.isManageDamageContactFlow.isBillmaAgentUser.content.bullet3"
                              )
                            )
                        ),
                      ]),
                    ]),
                    _c("br"),
                    _c("p", { staticClass: "text-medium subtitle_p" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "claim.onboarding.isManageDamageContactFlow.isBillmaAgentUser.content.literal4"
                          )
                        )
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]
        : _vm.isManageDamageBillmaFlow
        ? [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "title mg mg--b-6 welcome" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("claim.onboarding.isManageDamageBillmaFlow.title")
                  )
                ),
              ]),
              _c("div", { staticClass: "subtitle" }, [
                _c("p", { staticClass: "text-medium mg mg--b-2 subtitle_p" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "claim.onboarding.isManageDamageBillmaFlow.content.literal1"
                      )
                    )
                  ),
                ]),
                _c("p", { staticClass: "text-medium mg mg--b-6 subtitle_p" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "claim.onboarding.isManageDamageBillmaFlow.content.literal2"
                        )
                      )
                  ),
                ]),
                _c("p", { staticClass: "text-medium subtitle_p" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "claim.onboarding.isManageDamageBillmaFlow.content.literal3"
                      )
                    )
                  ),
                ]),
              ]),
            ]),
          ]
        : _vm._e(),
      _c("ma-confirm-button", {
        attrs: {
          handleButtonClick: _vm.handleClickStartBtn,
          title: _vm.$t("claim.onboarding.actions.mainBlue"),
          btnType: "startBtn",
        },
      }),
      _c(
        "ma-modal",
        {
          ref: "modalCookiesAndLegal",
          staticClass: "modal-confirmation",
          attrs: {
            type: "initial",
            closeIsHidden: "",
            isLegalData: _vm.showCookiesValue || _vm.showLegalValue,
          },
        },
        [
          _c("template", { slot: "modalContent" }, [
            _c("div", { staticClass: "modal__main" }, [
              _vm.showGeneralValue
                ? _c(
                    "div",
                    { staticClass: "general" },
                    [
                      _c("h2", { staticClass: "title-legal" }, [
                        _vm._v(_vm._s(_vm.$t("cookiesAndLegal.general.title"))),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(_vm.$t("cookiesAndLegal.general.paragraph1"))
                        ),
                      ]),
                      _c("br"),
                      _c(
                        "p",
                        {
                          staticClass: "text-link",
                          on: {
                            click: function ($event) {
                              return _vm.handleShowCookies()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "blueDark" }, [
                            _vm._v(
                              _vm._s(_vm.$t("cookiesAndLegal.cookies.title"))
                            ),
                          ]),
                        ]
                      ),
                      _c("br"),
                      _c(
                        "p",
                        {
                          staticClass: "text-link",
                          on: {
                            click: function ($event) {
                              return _vm.handleShowLegal()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "blueDark" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cookiesAndLegal.cookies.paragraph2.title"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("br"),
                      _c("br"),
                      _c("ma-confirm-button", {
                        attrs: {
                          handleButtonClick: _vm.closeModalCookiesAndLegal,
                          title: _vm.$t("actions.accept"),
                          btnType: "non-fixedBtn",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showCookiesValue
                ? _c(
                    "div",
                    { staticClass: "cookies" },
                    [
                      _c("h2", { staticClass: "title-legal" }, [
                        _vm._v(_vm._s(_vm.$t("cookiesAndLegal.cookies.title"))),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph1.list1")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph1.list2")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph1.list3")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph1.list4")
                          )
                        ),
                      ]),
                      _c("h3", { staticClass: "subtitle-legal" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.title")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.body")
                          )
                        ),
                      ]),
                      _c("ul", { staticClass: "list-legal" }, [
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.cookies.paragraph2.list1")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.cookies.paragraph2.list2")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.cookies.paragraph2.list3")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.cookies.paragraph2.list4")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.cookies.paragraph2.list5")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.cookies.paragraph2.list6")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.cookies.paragraph2.list7")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.cookies.paragraph2.list8")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cookiesAndLegal.cookies.paragraph2.list9"
                                )
                              )
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cookiesAndLegal.cookies.paragraph2.list9_1"
                                )
                              )
                            ),
                          ]),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "cookiesAndLegal.cookies.paragraph2.list10"
                              )
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "cookiesAndLegal.cookies.paragraph2.list11"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.footer")
                          )
                        ),
                      ]),
                      _c("h3", { staticClass: "subtitle-legal" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph3.title")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph3.body")
                          )
                        ),
                      ]),
                      _c("ul", { staticClass: "list-legal" }, [
                        _c("li", { staticClass: "item-legal" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cookiesAndLegal.cookies.paragraph3.list1"
                                )
                              )
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cookiesAndLegal.cookies.paragraph3.list1_1"
                                )
                              )
                            ),
                          ]),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cookiesAndLegal.cookies.paragraph3.list2"
                                )
                              )
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cookiesAndLegal.cookies.paragraph3.list2_1"
                                )
                              )
                            ),
                          ]),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cookiesAndLegal.cookies.paragraph3.list3"
                                )
                              )
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cookiesAndLegal.cookies.paragraph3.list3_1"
                                )
                              )
                            ),
                          ]),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cookiesAndLegal.cookies.paragraph3.list4"
                                )
                              )
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cookiesAndLegal.cookies.paragraph3.list4_1"
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _c("h3", { staticClass: "subtitle-legal" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph4.title")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph4.body")
                          )
                        ),
                      ]),
                      _c("ma-confirm-button", {
                        attrs: {
                          handleButtonClick: _vm.handleShowGeneral,
                          title: _vm.$t("actions.goBack"),
                          btnType: "non-fixedBtn",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showLegalValue
                ? _c(
                    "div",
                    { staticClass: "legal" },
                    [
                      _c("h2", { staticClass: "title-legal" }, [
                        _vm._v(_vm._s(_vm.$t("cookiesAndLegal.cookies.title"))),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph1.list1")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph1.list2")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph1.list3")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph1.list4")
                          )
                        ),
                      ]),
                      _c("h3", { staticClass: "subtitle-legal" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.title")
                          )
                        ),
                      ]),
                      _c("h3", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.body")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.list1")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.list2")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.list3")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.list4")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.list5")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.list6")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.list7")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.list8")
                          )
                        ),
                      ]),
                      _c("h3", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.list9")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.list9_1")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.list2")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph2.list3")
                          )
                        ),
                      ]),
                      _c("h3", { staticClass: "subtitle-legal" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph3.title")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph3.list1")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph3.list2")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph3.list3")
                          )
                        ),
                      ]),
                      _c("h3", { staticClass: "subtitle-legal" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph4.title")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph4.title")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.cookies.paragraph4.body")
                          )
                        ),
                      ]),
                      _c("ul", { staticClass: "list-legal" }, [
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.legal.paragraph4.list1")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.legal.paragraph4.list2")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.legal.paragraph4.list3")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.legal.paragraph4.list4")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.legal.paragraph4.list5")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.legal.paragraph4.list6")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.legal.paragraph4.list7")
                            )
                          ),
                        ]),
                        _c("li", { staticClass: "item-legal" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("cookiesAndLegal.legal.paragraph4.list8")
                            )
                          ),
                        ]),
                      ]),
                      _c("h3", { staticClass: "subtitle-legal" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.legal.paragraph5.title")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.legal.paragraph5.list1")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.legal.paragraph5.list2")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.legal.paragraph5.list3")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.legal.paragraph5.list4")
                          )
                        ),
                      ]),
                      _c("h3", { staticClass: "subtitle-legal" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.legal.paragraph6.title")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.legal.paragraph6.list1")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.legal.paragraph6.list2")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.legal.paragraph6.list3")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.legal.paragraph6.list4")
                          )
                        ),
                      ]),
                      _c("h3", { staticClass: "subtitle-legal" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.legal.paragraph7.title")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.legal.paragraph7.list1")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "main-paragraph" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cookiesAndLegal.legal.paragraph7.list2")
                          )
                        ),
                      ]),
                      _c("ma-confirm-button", {
                        attrs: {
                          handleButtonClick: _vm.handleShowGeneral,
                          title: _vm.$t("actions.goBack"),
                          btnType: "non-fixedBtn",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }